/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  deleteInboxIcon(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/icon`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  getClassification(data) {
    return axios.get(`${this.baseUrl()}/contact_classifications`)
  }
  setClassification(data) {
    return axios.post(`${this.baseUrl()}/contact_classifications`,data)
  }
  deleteClassification(id) {
    return axios.delete(`${this.baseUrl()}/contact_classifications/${id}`)
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  enableWhatsappCalling(inboxId) {
    return axios.post(`${this.url}/${inboxId}/enable_whatsapp_calling`);
  }

  disableWhatsappCalling(inboxId) {
    return axios.post(`${this.url}/${inboxId}/disable_whatsapp_calling`);
  }

  setInboundCalls(inboxId, enabled) {
    return axios.post(`${this.url}/${inboxId}/set_inbound_calls`, {
      inbound_calls_enabled: enabled,
    });
  }

  setCallRecording(inboxId, enabled) {
    return axios.post(`${this.url}/${inboxId}/set_call_recording`, {
      recording_enabled: enabled,
    });
  }

  updateProviderConfig(inboxId, providerConfig) {
    return axios.post(`${this.url}/${inboxId}/update_provider_config`, {
      provider_config: providerConfig,
    });
  }
}

export default new Inboxes();
